import { Form as FormR } from 'react-bootstrap';
import NavBar from "../NavBar/navbar";
import "./customer.css"
import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { useContext, useEffect, useRef } from 'react';
import { Input, Popconfirm, Form , Table, Typography } from 'antd';
import axios from 'axios';
import SubNavBar from "../SubNavBar/subnavbar";
import { Grid, Row, Col, Container, Button} from 'react-bootstrap';
import Collapse from 'react-bootstrap/Collapse';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { getToken, getTokenUser } from '../../helper/token';

function Customer() {

    //#region state managment

        //#region Validation States

        // Bootstrap

        

        // Create
        const [loggedInUser,setLoggedInUser] = useState(getTokenUser());
        axios.defaults.headers.common['Authorization'] = loggedInUser.token;
        const [isCustomerNameInputValid, setIsCustomerNameInputValid] = useState(true);
        const [customerNameInputError, setCustomerNameInputError] = useState("Default Error");

        const [isCustomerEmailInputValid, setIsCustomerEmailInputValid] = useState(true);
        const [customerEmailInputError, setCustomerEmailInputError] = useState("Default Error");
        
        const [isCustomerAddressInputValid, setIsCustomerAddressInputValid] = useState(true);
        const [customerAddressInputError, setCustomerAddressInputError] = useState("Default Error");

        // Update



        //#endregion

    const state = useLocation(); 
    
    const [isCreateValidated, setIsCreateValidated] = useState(false);

    const [paymentTerms, setPaymentTerms] = useState([]);
    //const [invoiceData, setInvoiceData] = useState([]);
    const [customers,setCustomers] = useState([]);
    const SERVER_URL = process.env.REACT_APP_PROD_SERVER_URL;
    const ACCOUNT_EMAIL = process.env.REACT_APP_ACCOUNTS_EMAIL;
    let customerId = 0;
    const [customerUpdateOpen, setCustomerUpdateOpen] = useState(false);
    const [customerTableOpen, setCustomerTableOpen] = useState(true);
    //const [proposalData, setProposalData] = useState([]);
    //const [invoiceData, setInvoiceData] = useState([]);
    const [addContactDetails, setAddContactDetails] = useState([{
        additionalContactId: 1,
        custId:0 ,
        additional_contactFull_name: "-",
        additional_contact_mobileNumber: "-",
        Additional_Contact_email_address: "-",
        AdditionalContactType:"client"
    }]);
    const [customer,setCustomer] = useState({});
    const navigate = useNavigate();
    const [isPageEdited,setPageEdited] = useState(false);

    try 
    {
        if (state.state != null) 
        {
            customerId = state.state.split('-')[0];
        }
    } 
    catch (error) 
    {
        alert(error);
    }
    
    

    //#endregion

    //#region Column definitions

    // const ProposalColumns=[{
    //     title:"Proposal Name",
    //     dataIndex:"proposal_name",
    //     editable:true
    // },
    // {
    //     title:"Proposal Date From",
    //     dataIndex:"proposal_date_from",
    //     editable:true
    // },
    // {
    //     title:"Proposal Date To",
    //     dataIndex:"proposal_date_to",
    //     editable:true
    // },
    // {
    //     title:"Proposal Unit QTY",
    //     dataIndex:"proposal_unit_qty",
    //     editable:true
    // },
    // {
    //     title:"Proposal Notes",
    //     dataIndex:"proposal_notes",
    //     editable:true
    // },
    // {
    //     title:"Proposal Unit Value",
    //     dataIndex:"proposal_unit_value",
    //     editable:true
    // },
    // {
    //     title:"Proposal SubTotal Exc",
    //     dataIndex:"proposal_subtotal_exc",
    //     editable:true
    // },
    // {
    //     title:"Proposal SubTotal Inc",
    //     dataIndex:"proposal_subtotal_inc",
    //     editable:true
    // },
    // {
    //     title:"Proposal Frequency QTY",
    //     dataIndex:"proposal_frequency_qty",
    //     editable:true
    // },
    // {
    //     title:"Proposal Frequency Type",
    //     dataIndex:"proposal_frequency_type",
    //     editable:true
    // },
    // {
    //     title:"Proposal Status",
    //     dataIndex:"proposal_status",
    //     editable:true
    // },
    // {
    //     title:"Proposal Total Exc",
    //     dataIndex:"proposal_total_exc",
    //     editable:true
    // },
    // {
    //     title:"Proposal Total Inc",
    //     dataIndex:"proposal_total_inc",
    //     editable:true
    // },
    // {
    //     title:"Actions",
    //     // render: (record) => <p onClick={() => (onProposalDelete(record.key))}>Delete</p>,
    //     render: (record) => <img className="delete-icon" src={require('./delete.png')} alt="Not Found!" onClick={() => (onProposalDelete(record.key))}/>,
    // }];

    // const InvoiceHeaderColumns =[
    // {
    //     title:"Invoice Description",
    //     dataIndex:"invoice_description",
    //     editable:true
    // },
    // {
    //     title:"Invoice Create Date",
    //     dataIndex:"invoice_create_date",
    //     editable:true
    // },
    // {
    //     title:"Invoice Date",
    //     dataIndex:"invoice_date",
    //     editable:true
    // },
    // {
    //     title:"Invoice Total Exc",
    //     dataIndex:"invoice_total_exc",
    //     editable:true
    // },
    // {
    //     title:"Invoice Total Inc",
    //     dataIndex:"invoice_total_inc",
    //     editable:true
    // },
    // {
    //     title:"Invoice Sent",
    //     dataIndex:"invoice_sent",
    //     editable:true
    // },
    // {
    //     title:"Invoice Paid",
    //     dataIndex:"invoice_paid",
    //     editable:true
    // },
    // {
    //     title:"Invoice Date Paid",
    //     dataIndex:"invoice_date_paid",
    //     editable:true
    // },
    // {
    //     title:"Invoice Ref",
    //     dataIndex:"invoice_ref",
    //     editable:true
    // },
    // {
    //     title:"Invoice Notes",
    //     dataIndex:"invoice_notes",
    //     editable:true
    // }];

    // const InvoiceLineColumns=[{
    //     title:"Invoice Line Description",
    //     dataIndex:"invoice_line_description",
    //     editable:true
    // },
    // {
    //     title:"Invoice Line Quantity",
    //     dataIndex:"invoice_line_quantity",
    //     editable:true
    // },
    // {
    //     title:"Invoice Line Unit Value",
    //     dataIndex:"invoice_line_unit_value",
    //     editable:true
    // },
    // {
    //     title:"Invoice Line Total Exc",
    //     dataIndex:"invoice_line_total_exc",
    //     editable:true
    // },
    // {
    //     title:"Invoice Line Total Inc",
    //     dataIndex:"invoice_line_total_inc",
    //     editable:true
    // },
    // {
    //     title:"Invoice Line Notes",
    //     dataIndex:"invoice_line_notes",
    //     editable:true
    // }];


    const AdditionalContactColumns=[{
        title:"AdditionalContactFullName",
        dataIndex:"additional_contactFull_name",
        editable:true
    },
    {
        title:"AdditionalContactMobileNumber",
        dataIndex:"additional_contact_mobileNumber",
        editable:true
    },
    {
        title:"AdditionalContactEmailAddress",
        dataIndex:"Additional_Contact_email_address",
        editable:true
    },
    {
        title:"Action",
        render: (record) => <img className="delete-icon" src={require('./delete.png')} alt="Not Found!" onClick={() => onAdditionalContactDelete(record)}/>,
    }]



    //#endregion

    //#region Ant Table States & Functions

    const EditableContext = React.createContext(null);
            

    const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
            <tr {...props} />
        </EditableContext.Provider>
        </Form>
    );
    };

    const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
    }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
        inputRef.current.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
        [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({
            ...record,
            ...values,
        });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
        <Form.Item
            style={{
            margin: 0,
            }}
            name={dataIndex}
            rules={[
            {
                required: true,
                message: `${title} is required.`,
            },
            ]}
        >
            <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
        ) : (
        <div
            className="editable-cell-value-wrap"
            style={{
            paddingRight: 24,
            }}
            onClick={toggleEdit}
        >
            {children}
        </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
    };

    const components = {
    body: {
        row: EditableRow,
        cell: EditableCell,
    },
    };

    const addContactColumns = AdditionalContactColumns.map((col) => {
    if (!col.editable) {
        return col;
    }
    return {
            ...col,
            onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
            }),
        };
    });

    // const inveHeadColumns = InvoiceHeaderColumns.map((col) => {
    //     if (!col.editable) {
    //         return col;
    //     }
    //     return {
    //         ...col,
    //         onCell: (record) => ({
    //         record,
    //         editable: col.editable,
    //         dataIndex: col.dataIndex,
    //         title: col.title,
    //         handleSave,
    //         }),
    //     };
    // });
    // const invLinecolumns = InvoiceLineColumns.map((col) => {
    //     if (!col.editable) {
    //         return col;
    //     }
    //     return {
    //         ...col,
    //         onCell: (record) => ({
    //         record,
    //         editable: col.editable,
    //         dataIndex: col.dataIndex,
    //         title: col.title,
    //         handleSave,
    //         }),
    //     };
    // });

    //#endregion

    //#region UI Population
    React.useEffect(()=>{
        // if (customerId != 0 && customerId !== null) 
        // {
        //     axios
        //     .get(SERVER_URL+'/api/Customer/GetCustomerDetails?customerID='+customerId,
        //     )
        //     .then((response) => {
        //         setCustomer({CustName: response.data.CustName, CustEmail: response.data.CustEmail, CustAddress:response.data.CustAddress, CustRegNo: response.data.CustRegNo, CustVatNo: response.data.CustVatNo, CustPaymentTerms: response.data.CustPaymentTerms, CustStatus:response.data.CustStatus, CustContactName:response.data.CustContactName, CustContactNo:response.data.CustContactNo, CustContactEmail:response.data.CustContactEmail, CustAdditionalContactName:response.data.CustAdditionalContactName, CustAdditionalContactNo:response.data.CustAdditionalContactNo, CustAdditionalContactEmail:response.data.CustAdditionalContactEmail})
        //         let tempProposalData = [];
        //         let tempProp = {};

        //         let tempInvoiceHeader={};
        //         response.data.Proposal.forEach(element => {
        //             tempProp = {key:element.PropId,
        //                 prop_customer_id:customerId,
        //                 proposal_name:element.PropName,
        //                 proposal_date_from:element.PropDateFrom,
        //                 proposal_date_to:element.PropDateTo,
        //                 proposal_notes:element.PropNotes,
        //                 proposal_status:element.PropStatus,
        //                 proposal_unit_qty:element.PropUnitQty,
        //                 proposal_unit_value:element.PropUnitValue,
        //                 proposal_subtotal_exc:element.PropSubTotalExc,
        //                 proposal_subtotal_inc:element.PropSubTotalInc,
        //                 proposal_frequency_qty:element.PropFreqQty,
        //                 proposal_frequency_type:element.PropFreqType,
        //                 proposal_total_exc:element.PropTotalExc,
        //                 proposal_total_inc:element.PropTotalInc,
        //                 proposal_type:'server',
        //                 invoiceHeader:[]
        //             }
        //             element.InvHeader.forEach(header=>{
        //                 tempInvoiceHeader = {key:header.InvId,
        //                     invoice_prop_id : element.PropId,
        //                     invoice_description:header.InvDesc,
        //                     invoice_create_date:header.InvCreateDate,
        //                     invoice_date:header.InvDate,
        //                     invoice_total_exc:header.InvTotalExc,
        //                     invoice_sent:header.InvSent,
        //                     invoice_paid:header.InvPaid,
        //                     invoice_date_paid:header.InvDatePaid,
        //                     invoice_ref:header.InvRef,
        //                     invoice_notes:header.InvNotes,
        //                     invoice_header_type:'server',
        //                     invoiceLines:[]}
        //                     header.InvLine.forEach(line=>{
        //                         let tempLine={
        //                             key:line.InvLineId,
        //                             invoice_master_prop_id:element.PropId,
        //                             invoice_line_headId: header.InvId,
        //                             invoice_line_description:line.InvLineDesc,
        //                             invoice_line_quantity:line.InvLineUnitQty,
        //                             invoice_line_unit_value:line.InvLineUnitValue,
        //                             invoice_line_total_exc:line.InvLineTotalExc,
        //                             invoice_line_total_inc:line.InvLineTotalInc,
        //                             invoice_line_notes:line.InvLineNotes,
        //                             invoice_line_type:'server'
        //                         }
        //                         tempInvoiceHeader.invoiceLines.push(tempLine);
        //                     })
        //                 tempProp.invoiceHeader.push(tempInvoiceHeader);
        //             });
        //             tempProposalData.push(tempProp)
        //         });
        //         //setProposalData(tempProposalData);
        //     })
        //     .catch(error => {
        //     console.log(error);
        //     });

            
        // }
        if (customerId == 0) {
            axios
            .get(SERVER_URL+'/api/Customer/GetPaymentTerm')
            .then((response) =>
                setPaymentTerms(response.data)
            )
        }
    },[])

    //#endregion
    
    //#region Functions
    const handleAdditionalContactAdd=()=>{

        let newRowKey = GetNewRowKey(addContactDetails);
       
        let date = new Date();
        const newData ={
            key:newRowKey,
            additionalContactId: newRowKey,
            custId:0 ,
            additional_contactFull_name: "-",
            additional_contact_mobileNumber: "-",
            Additional_Contact_email_address: "-",
            AdditionalContactType:"client"
            
        }
        setAddContactDetails([...addContactDetails, newData]);
    };

        //#region Validation Functions

        const handleCustomerNameInputChange = (e, action) => {
            let customerName = e.target.value;
            let isValid = !/[^a-z]/i.test(customerName);

            if (customerName === "") 
            {
                if (action === "create") 
                {
                    setCustomerNameInputError("Required");
                    setIsCustomerNameInputValid(false);
                }
                else if (action === "update")
                {

                }
            }            
            else if (isValid === false) 
            {
                if (action === "create") 
                {
                    setCustomerNameInputError("Only letters allowed");
                    setIsCustomerNameInputValid(false);
                }
                else if (action === "update")
                {

                }
            }
            else
            {
                if (action === "create") 
                {
                    setIsCustomerNameInputValid(true);
                }
                else if (action === "update")
                {

                }
            }
        }

        const handleCustomerEmailInputChange = (e, action) => {
            let customerEmail = e.target.value;
            let isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(customerEmail);

            if (customerEmail === "") 
            {
                if (action === "create") 
                {
                    setCustomerEmailInputError("Required");
                    setIsCustomerEmailInputValid(false);
                }
                else if (action === "update")
                {

                }
            }   
            else if (isValid === false) 
            {
                if (action === "create") 
                {
                    setCustomerEmailInputError("Please enter a valid email address");
                    setIsCustomerEmailInputValid(false);
                }
                else if (action === "update")
                {

                }
            }
            else
            {
                if (action === "create") 
                {
                    setIsCustomerEmailInputValid(true);
                }
                else if (action === "update")
                {

                }
            }
        }

        const handleCustomerAddressInputChange = (e, action) => {
            let customerAddress = e.target.value;

            if (customerAddress === "") 
            {
                if (action === "create") 
                {
                    setCustomerAddressInputError("Required");
                    setIsCustomerAddressInputValid(false);
                }
                else if (action === "update")
                {

                }
            } 
            else
            {
                if (action === "create") 
                {
                    setIsCustomerAddressInputValid(true);
                }
                else if (action === "update")
                {

                }
            }
        }

        //#endregion

    const notifySuccessful = (message) => {
        toast.success(message, {
          position: "bottom-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      };
    
    const notifyFailed = (message) => {
        toast.error(message, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    // function SaveTable(){
    //     try {   
    //             let postedData = [];
    //             let tempHeader={}
    //             let tempProp=[];

    //             proposalData.forEach(proposal=>{
    //                 tempProp = {PropId:parseInt(proposal.key),
    //                     CustId:parseInt(proposal.prop_customer_id),
    //                     PropName:proposal.proposal_name,
    //                     PropDateFrom:proposal.proposal_date_from,
    //                     PropDateTo:proposal.proposal_date_to,
    //                     PropNotes:proposal.proposal_notes,
    //                     PropUnitQty:parseInt(proposal.proposal_unit_qty),
    //                     PropUnitValue:parseFloat(proposal.proposal_unit_value),
    //                     PropSubTotalExc:parseFloat(proposal.proposal_subtotal_exc),
    //                     PropSubTotalInc:parseFloat(proposal.proposal_subtotal_inc),
    //                     PropFreqQty:parseInt(proposal.proposal_frequency_qty),
    //                     PropFreqType:proposal.proposal_frequency_type,
    //                     PropTotalExc:parseFloat(proposal.proposal_total_exc),
    //                     PropStatus:proposal.proposal_status,
    //                     PropTotalInc:parseFloat(proposal.proposal_total_inc),
    //                     PropType:proposal.proposal_type,
    //                     InvHeader:[]
    //                 }

    //                 proposal.invoiceHeader.forEach(header=>{
            
    //                     //if(isNaN(parseInt(invoiceId))|isNaN(parseInt(line.invoice_line_quantity))|isNaN(parseInt(line.invoice_line_unit_value))|isNaN(parseInt(line.invoice_line_total_exc))|isNaN(parseInt(line.invoice_line_total_inc)) ){
    //                         // throw new Error('ValidationError');
    //                         //}
                           
    //                         tempHeader = {
    //                             InvId : parseInt(header.key),
    //                             InvDesc:header.invoice_description,
    //                             PropId :parseInt(proposal.key),
    //                             InvCreateDate:header.invoice_create_date,
    //                             InvDate:header.invoice_date,
    //                             InvTotalExc:parseFloat(header.invoice_total_exc),
    //                             InvTotalInc:parseFloat(header.invoice_total_inc),
    //                             InvSent:header.invoice_sent,
    //                             InvPaid:header.invoice_paid,
    //                             InvDatePaid:header.invoice_date_paid,
    //                             InvRef:header.invoice_ref,
    //                             InvNotes:header.invoice_notes,
    //                             InvHeaderType:header.invoice_header_type,
    //                             InvLine:[]
    //                         }
                            
        
    //                         header.invoiceLines.forEach(line => {
    //                         let tempLine={
    //                             InvLineId:parseInt(line.key),
    //                             InvId:parseInt(line.key),
    //                             InvLineDesc:line.invoice_line_description,
    //                             InvLineUnitQty:parseFloat(line.invoice_line_quantity),
    //                             InvLineUnitValue:parseFloat(line.invoice_line_unit_value),
    //                             InvLineTotalExc:parseFloat(line.invoice_line_total_exc),
    //                             InvLineTotalInc:parseFloat(line.invoice_line_total_inc),
    //                             InvLineNotes:line.invoice_line_notes,
    //                             InvLineType:line.invoice_line_type
    //                         }
    //                         tempHeader.InvLine.push(tempLine);
    //                     });
    //                     tempProp.InvHeader.push(tempHeader);
    //                 })
    //                 postedData.push(tempProp);
    //             });

            
    //         axios
    //         .post(SERVER_URL+'/api/Proposal/CreateProposal',
    //         postedData
    //         ).then((response)=>{
    //             alert("Success");
    //         }).catch((Error)=>{
    //             if(Error =='ValidationError'){
    //                 console.log(Error);
    //             }
    //             console.log(Error);
    //         });
    //     } catch (errInfo) {
    //       console.log('Validate Failed:', errInfo);
    //     }
    //   };

    // function SaveCustomer(){
    // };

    function GetNewRowKey(listItems){
        let biggestKey = 0;
        listItems.forEach(element => {
            if(element.key>biggestKey){
                biggestKey=element.key;
            }
        });
        biggestKey = biggestKey+1;
        return biggestKey;
    }

    const handleSave = (row) => {
        setPageEdited(true);
        const newData = [...addContactDetails];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
        ...item,
        ...row,
        });
        setAddContactDetails(newData);
    };

    // const handleProposalAdd = () => {
    // const tempProp = {key: GetNewRowKey(proposalData),
    //     prop_customer_id:customerId,
    //     proposal_name:'Proposal Name Example',
    //     proposal_date_from:'Date Example',
    //     proposal_date_to:'Date Example',
    //     proposal_notes:'Notes Example',
    //     proposal_unit_qty:0,
    //     proposal_unit_value:0,
    //     proposal_subtotal_exc:0,
    //     proposal_status:'Example Status',
    //     proposal_subtotal_inc:0,
    //     proposal_frequency_qty:0,
    //     proposal_frequency_type:0,
    //     proposal_total_exc:0,
    //     proposal_total_inc:0,
    //     proposal_type:'client',
    //     invoiceHeader:[]
    // }
    // setProposalData([...proposalData, tempProp]);
    // };

    // const handleInvoiceHeaderAdd = (dataSource) => {
    // if(dataSource.invoiceHeader.length==0){
    //     const tempInvoiceHeader = {key:1,
    //         invoice_prop_id:dataSource.key,
    //         invoice_description:"Description example",
    //         invoice_create_date:"Example Date",
    //         invoice_date:"Description example",
    //         invoice_total_exc:0,
    //         invoice_total_inc:0,
    //         invoice_sent:"Na",
    //         invoice_paid:"Na",
    //         invoice_date_paid:"Example Date",
    //         invoice_ref:"Example Ref",
    //         invoice_notes:"Example Notes",
    //         invoice_header_type:'server',
    //         //invoice_type:'client',
    //         invoiceLines:[]
    //     }

    //     const newLines = [...dataSource.invoiceHeader];

    //     newLines.push(tempInvoiceHeader);

    //     //const index = invoiceData.findIndex((item) =>  === item.key);
    //     const newState = proposalData.map(proposal => {
    //         if (proposal.key === dataSource.key) {
    //             return {...proposal,invoiceHeader:newLines};
    //         }
    //         return proposal;
    //         });
    //         setProposalData(newState);

    //     //setInvoiceData([...invoiceData, newData]);
    // }
    // else
    // {
    //     let newKey = GetNewRowKey(dataSource.invoiceHeader);

    //     let tempInvoiceHeader = {key:newKey,
    //         invoice_prop_id:dataSource.key,
    //         invoice_description:"Description example",
    //         invoice_create_date:"Example Date",
    //         invoice_date:"Description example",
    //         invoice_total_exc:0,
    //         invoice_sent:"Na",
    //         invoice_paid:"Na",
    //         invoice_date_paid:"Example Date",
    //         invoice_ref:"Example Ref",
    //         invoice_notes:"Example Notes",
    //         invoice_header_type:'server',
    //         invoiceLines:[]
    //     }
    //     const newLines = [...dataSource.invoiceHeader];

    //     newLines.push(tempInvoiceHeader);

    //     //const index = invoiceData.findIndex((item) =>  === item.key);
    //     const newState = proposalData.map(proposal => {
    //         if (proposal.key === dataSource.invoiceHeader[0].invoice_prop_id) {
    //             return {...proposal,invoiceHeader:newLines};
    //         }
    //         return proposal;
    //         });
    //         setProposalData(newState);
    //     //setInvoiceData([...invoiceData, newData]);
    // }
    // };

    // const handleInvoiceLineAdd = (dataSource) => {
    // let recordKey = 0;
    // let invoiceIndex = 0;
    // if(dataSource.invoiceLines.length==0){
    //     // recordKey=1;
    //     // invoiceIndex = invoiceData.length

    //     const newData = {
    //     key: 1,
    //     invoice_line_description:"Description example",
    //     invoice_master_prop_id:dataSource.invoice_prop_id,
    //     invoice_line_headId:dataSource.key,
    //     invoice_line_quantity: 0,
    //     invoice_line_unit_value: 0,
    //     invoice_line_total_exc:0,
    //     invoice_line_total_inc:0,
    //     invoice_line_notes:"Notes example",
    //     invoice_line_type:'client',
    //     };
    //     //setPageEdited(true);
    //     const newLines = [...dataSource.invoiceLines];
    //     newLines.push(newData);
    //     const proposalIndex = proposalData.findIndex((itemline) => dataSource.invoice_prop_id===itemline.key);
    //     const headerIndex = proposalData[proposalIndex].invoiceHeader.findIndex((header)=>dataSource.key === header.key);

    //     //proposalData[proposalIndex].invoiceHeader[headerIndex].invoiceLines = [newData];
    //     const newState = proposalData.map(prop => {
    //         if(prop.key===dataSource.invoice_prop_id){
    //             //prop.invoiceHeader 
    //             const invoiceHeaders = prop.invoiceHeader.map(header=>{
    //                 if (header.key === dataSource.key) {
    //                     return {...header, invoiceLines: newLines};
    //                 }
    //                 return header;
    //             })
    //             return {...prop,invoiceHeader: invoiceHeaders};
    //             return prop;
    //         }
    //         return prop;
    //         });
    //         setProposalData(newState);
    // }
    // else{
    //     let lineKey = GetNewRowKey(dataSource.invoiceLines);
    //     const newData = {
    //         key: lineKey,
    //         invoice_line_description:"Description example",
    //         invoice_line_headId:dataSource.key,
    //         invoice_line_quantity: 0,
    //         invoice_line_unit_value: 0,
    //         invoice_line_total_exc:0,
    //         invoice_line_total_inc:0,
    //         invoice_line_notes:"Notes example",
    //         invoice_line_type:'client',
    //     };
    //     //setPageEdited(true);
    //     const newLines = [...dataSource.invoiceLines];

    //     newLines.push(newData);

    //     //const index = invoiceData.findIndex((item) =>  === item.key);
    //     const newState = proposalData.map(prop => {
    //         if(prop.key===dataSource.invoice_prop_id){
    //             //prop.invoiceHeader 
    //             let invoiceHeaders = prop.invoiceHeader.map(header=>{
    //                 if (header.key === dataSource.invoiceLines[0].invoice_line_headId) {
    //                     return {...header, invoiceLines: newLines};
    //                 }
    //                 return header;
    //             })
    //             return {...prop, invoiceHeader:invoiceHeaders}//invoiceHeader = invoiceHeaders;
    //             //return prop;
    //         }
    //         return prop;
    //         });
    //         setProposalData(newState);
    //     }        
    // };

    // function onCustomerChange(proposalChange)
    // {

    //     switch (proposalChange.attribute) {

    //         case "cust_Name":
    //             setCustomer({...customer, cust_Name: proposalChange.value});
    //             break;

    //         case "cust_Email":
    //             setCustomer({...customer, cust_Email: proposalChange.value});
    //             break;

    //         case "cust_Address":
    //             setCustomer({...customer, cust_Address: proposalChange.value});
    //             break;

    //         case "cust_RegNo":
    //             setCustomer({...customer, cust_RegNo: proposalChange.value});
    //             break;

    //         case "cust_VatNo":
    //             setCustomer({...customer, cust_VatNo: proposalChange.value});
    //             break;
        
    //         case "cust_ContactNo":
    //             setCustomer({...customer, cust_ContactNo: proposalChange.value});
    //             break;

    //         case "cust_PaymentTerms":
    //             setCustomer({...customer, cust_PaymentTerms: proposalChange.value});
    //             break;

    //         case "cust_Status":
    //             setCustomer({...customer, cust_Status: proposalChange.value});
    //             break;
    //         default:
    //             break;
    //     }
    // }

    function onCustomerUpdateFormSubmitHandler(event){

        event.preventDefault();
        
        let updatedCustomer = {
            CustId: parseInt(customerId),
            CustName: event.target.elements.UpdateCustName.value,
            CustAddress: event.target.elements.UpdateCustAddress.value,
            CustRegNo: event.target.elements.UpdateCustRegNo.value,
            CustVatNo: event.target.elements.UpdateCustVatNo.value,
            CustEmail: event.target.elements.UpdateCustEmail.value,
            CustPaymentTerms: event.target.elements.UpdateCustPaymentTerms.value,
            CustStatus: event.target.elements.UpdateCustStatus.value,
            
            CustAdditionalContactName: event.target.elements.UpdateCustAdditionalName.value,
            CustAdditionalContactNo: event.target.elements.UpdateCustAdditionalNo.value,
            CustAdditionalContactEmail: event.target.elements.UpdateCustAdditionalEmail.value};

        axios
        .post(SERVER_URL+'/api/Customer/updateCustomer',
        updatedCustomer
        )
        .then((response) => {
            notifySuccessful("Customer Updated!");
           
        })
        .catch(error => {
        console.log(error);
        notifyFailed("An Error Occured, Please Try Again.");
        });
        
    };
    //CREATE
    function onCustomerCreateFormSubmitHandler(event)
    {
        event.preventDefault();

        const form = event.currentTarget;
            if (form.checkValidity() === false) 
            {
              event.preventDefault();
              event.stopPropagation();
            }
            else
            {
                let customerExist = false;

                axios
                .get(SERVER_URL+'/api/Customer/GetCustomers')
                .then((response) => {
                    setCustomers(response.data)
                })
                .catch(error => {
                    console.log(error);
                    notifyFailed("Failed to retrieve customers");
                })

                for (const cust of customers) {
                    if ( event.target.elements.CreateCustName.value == cust.CustName) {
                        customerExist = true;
                        break
                    } 
                }

                if (customerExist) {
                    notifyFailed("Customer already exists!")
                } else {
                    let createdCustomer = {
                        // CONFIRM WITH ETIENNE
                        UserId: 1,
                        CustStatus: "Active",
                        CustName: event.target.elements.CreateCustName.value,
                        CustAddress: event.target.elements.CreateCustAddress.value,
                        CustRegNo: event.target.elements.CreateCustRegNo.value,
                        CustVatNo: event.target.elements.CreateCustVatNo.value,
                        CustEmail: event.target.elements.CreateCustEmail.value,
                        CustPaymentTermId: Number(event.target.elements.CreateCustPaymentTerms.value),
                    }
                    axios
                    .post(SERVER_URL+'/api/Customer/CreateNewCustomer',
                    createdCustomer
                    )
                    .then((response) => {
                        notifySuccessful("Customer Created!");
                        addContactDetails.forEach(element => {
                            if(element.additional_contactFull_name!='-'){
                                let tempAddContact = {
                                    additionalContactId: element.newRowKey,
                                    CustomerId:response.data.custId,
                                    AdditionalContactFullName:element.additional_contactFull_name,
                                    AdditionalContactMobileNumber:element.additional_contact_mobileNumber,
                                    AdditionalContactEmailAddress:element.Additional_Contact_email_address,
                                    AdditionalContactType:element.AdditionalContactType
                                }
                                axios
                                .post(SERVER_URL+'/api/Customer/SaveAdditionalContact',
                                tempAddContact).then((response) => {
                                }).catch(error=>{
                                    console.log(error)
                                });
                            }
                        });
                        // Implement when email is available
                        sendEmail(createdCustomer);
                        setTimeout(function () {
                            navigate('/customerlistview');
                        }, 2000);
                    })
                    .catch(error => {
                    console.log(error);
                    notifyFailed("An Error Occured, Please Try Again.");
                    });
                }
            }
        setIsCreateValidated(true);
    };

    function onAdditionalContactDelete(row)
    {
        let addContactCopy = [...addContactDetails];
        let deleteAddContactIndex = addContactCopy.findIndex(x => x.key === row.key);
        addContactCopy.splice(deleteAddContactIndex, 1);
        setAddContactDetails(addContactCopy);
    }

    function onCustomerNameChange(event) 
    {
        event.preventDefault();

        axios
        .get(SERVER_URL+'/api/Customer/GetCustomers')
        .then((response) => {
            setCustomers(response.data)
        })
        .catch(error => {
            console.log(error);
            notifyFailed("Failed to retrieve customers");
        })

        for (const cust of customers) {
            if ( event.target.value == cust.CustName) {
                notifyFailed("Customer already exists");
                break
            }
        }

        // handleCustomerNameInputChange(event, "create");
    };

    // function onProposalDelete(deleteProposalId)
    // {
    //     axios
    //     .delete(SERVER_URL+'/api/Proposal/DeleteProposal/?proposalId=' + deleteProposalId
    //     )
    //     .then((response) => {
    //         axios
    //         .get(SERVER_URL+'/api/Customer/GetCustomerDetails?customerID='+customerId,
    //         )
    //         .then((response) => {
    //             setCustomer({CustName: response.data.CustName, CustEmail: response.data.CustEmail, CustAddress:response.data.CustAddress, CustRegNo: response.data.CustRegNo, CustVatNo: response.data.CustVatNo, CustPaymentTerms: response.data.CustPaymentTerms, CustStatus:response.data.CustStatus, CustContactName:response.data.CustContactName, CustContactNo:response.data.CustContactNo, CustContactEmail:response.data.CustContactEmail, CustAdditionalContactName:response.data.CustAdditionalContactName, CustAdditionalContactNo:response.data.CustAdditionalContactNo, CustAdditionalContactEmail:response.data.CustAdditionalContactEmail})
    //             let tempProposalData = [];
    //             let tempProp = {};

    //             let tempInvoiceHeader={};
    //             response.data.Proposal.forEach(element => {
    //                 tempProp = {key:element.PropId,
    //                     prop_customer_id:customerId,
    //                     proposal_name:element.PropName,
    //                     proposal_date_from:element.PropDateFrom,
    //                     proposal_date_to:element.PropDateTo,
    //                     proposal_notes:element.PropNotes,
    //                     proposal_status:element.PropStatus,
    //                     proposal_unit_qty:element.PropUnitQty,
    //                     proposal_unit_value:element.PropUnitValue,
    //                     proposal_subtotal_exc:element.PropSubTotalExc,
    //                     proposal_subtotal_inc:element.PropSubTotalInc,
    //                     proposal_frequency_qty:element.PropFreqQty,
    //                     proposal_frequency_type:element.PropFreqType,
    //                     proposal_total_exc:element.PropTotalExc,
    //                     proposal_total_inc:element.PropTotalInc,
    //                     proposal_type:'server',
    //                     invoiceHeader:[]
    //                 }
    //                 element.InvHeader.forEach(header=>{
    //                     tempInvoiceHeader = {key:header.InvId,
    //                         invoice_prop_id : element.PropId,
    //                         invoice_description:header.InvDesc,
    //                         invoice_create_date:header.InvCreateDate,
    //                         invoice_date:header.InvDate,
    //                         invoice_total_exc:header.InvTotalExc,
    //                         invoice_sent:header.InvSent,
    //                         invoice_paid:header.InvPaid,
    //                         invoice_date_paid:header.InvDatePaid,
    //                         invoice_ref:header.InvRef,
    //                         invoice_notes:header.InvNotes,
    //                         invoice_header_type:'server',
    //                         invoiceLines:[]}
    //                         header.InvLine.forEach(line=>{
    //                             let tempLine={
    //                                 key:line.InvLinelId,
    //                                 invoice_master_prop_id:element.PropId,
    //                                 invoice_line_headId: header.InvId,
    //                                 invoice_line_description:line.InvLineDesc,
    //                                 invoice_line_quantity:line.InvLineUnitQty,
    //                                 invoice_line_unit_value:line.InvLineUnitValue,
    //                                 invoice_line_total_exc:line.InvLineTotalExc,
    //                                 invoice_line_total_inc:line.InvLineTotalInc,
    //                                 invoice_line_notes:line.InvLineNotes,
    //                                 invoice_line_type:'server'
    //                             }
    //                             tempInvoiceHeader.invoiceLines.push(tempLine);
    //                         })
    //                     tempProp.invoiceHeader.push(tempInvoiceHeader);
    //                 });
    //                 tempProposalData.push(tempProp)
    //             });
    //             setProposalData(tempProposalData);
    //             alert("Success");
    //         })
    //         .catch(error => {
    //         console.log(error);
    //         });
    //     })
    //     .catch(error => {
    //     console.log(error);
    //     });
    // }; 
    
    function sendEmail(customer) {
        let user = getTokenUser()
        let message = {
            toEmails: [ACCOUNT_EMAIL, user.email],
            subject: "New customer created: " + customer.CustName,
            body: "A new customer has been added on the BCI Finance App." +
                "<br><b>Name:</b> "+ customer.CustName +
                "<br><b>Email Address:</b> "+ customer.CustEmail +
                "<br><b>Address:</b> "+ customer.CustAddress +
                "<br><b>Registration Number:</b> "+ customer.CustRegNo +
                "<br><b>Vat Number:</b> "+ customer.CustVatNo +
                "<br><br>This customer was created by: "+ user.firstName + " " + user.surname
        }
        
        axios
        .post(SERVER_URL+'/api/Email/Send',
        message
        )
        .catch(error => {
            console.log(error)
        })
    }

    //#endregion

    return (
      <div>
        <ToastContainer />
        <NavBar/>
        {   customerId != 0 && customerId != null &&
            <SubNavBar values={[{heading: "Account Manager", text: "Lothar Schroder"},{heading: "Onboard Date", text: "2023/01/01"},{heading: "Number of Proposals", text: "3"}]}></SubNavBar>
        }        

        {   customerId != 0 &&
            <Container fluid>
                <div className="customer-collapse-toggle-container">
                    <Row className="customer-collapse-toggle-wrapper gx-0" >
                        <Col>
                            <p className="customer-collapse-toggle" onClick={() => setCustomerUpdateOpen(!customerUpdateOpen)} aria-controls="example-collapse-text" aria-expanded={customerUpdateOpen}>Update Customer</p>
                        </Col>
                    </Row>
                    <Collapse className="customer-collapse-content gx-0" in={customerUpdateOpen}>
                        <Row className="justify-content-md-center">
                            <Col className="customer-update-collapse-body" md={6}>
                                <div id="customer-update-form">
                                    {/* <p className='customer-body-details-heading'>Customer Information</p> */}
                                    <FormR onSubmit={onCustomerUpdateFormSubmitHandler}>
                                        <FormR.Group className="mb-3" controlId="formBasicUsername">
                                            <div className='row justify-content-center customer-input-row'>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Customer Name</h2>
                                                    <FormR.Control id="UpdateCustName" type="text" defaultValue={customer.CustName}></FormR.Control>
                                                </div>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Email Address</h2>
                                                    <FormR.Control id="UpdateCustEmail" type="text" defaultValue={customer.CustEmail}></FormR.Control>
                                                </div>
                                            </div>
                                            <div className='row justify-content-center customer-input-row'>
                                                <div className='col-12'>
                                                    <h2 className='customer-update-input-title'>Address</h2>
                                                    <FormR.Control id="UpdateCustAddress" type="text" defaultValue={customer.CustAddress}></FormR.Control>
                                                </div>
                                            </div>
                                            <div className='row justify-content-center customer-input-row'>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Reg Number</h2>
                                                    <FormR.Control id="UpdateCustRegNo" type="text" defaultValue={customer.CustRegNo}></FormR.Control>
                                                </div>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>VAT Number</h2>
                                                    <FormR.Control id="UpdateCustVatNo" type="text" defaultValue={customer.CustVatNo}></FormR.Control>
                                                </div>
                                            </div>
                                            <div className='row justify-content-center customer-input-row'>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Payment Terms</h2>
                                                    <FormR.Select id="UpdateCustPaymentTerms"> {/* type="text" defaultValue={customer.CustPaymentTerms}>*/}
                                                        <option>Select Payment Term</option>
                                                        <option value="1">30</option>
                                                        <option value="2">60</option>
                                                        <option value="3">90</option>
                                                    </FormR.Select>
                                                </div>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Status</h2>
                                                    <FormR.Control id="UpdateCustStatus" type="text" defaultValue={customer.CustStatus}></FormR.Control>
                                                </div>
                                            </div>

                                            <br/>

                                            <div className='row justify-content-center customer-input-row'>
                                                
                                            </div>
                                            <div className='row justify-content-center customer-input-row'>
                                            
                                            </div>

                                            <br/>

                                            <div className='row justify-content-center customer-input-row'>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Additional Contact Name & Surname</h2>
                                                    <FormR.Control id="UpdateCustAdditionalName" type="text" defaultValue={customer.CustAdditionalContactName}></FormR.Control>
                                                </div>
                                                <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Additional Contact Mobile Number</h2>
                                                    <FormR.Control id="UpdateCustAdditionalNo" type="text" defaultValue={customer.CustAdditionalContactNo}></FormR.Control>
                                                </div>
                                            </div>
                                            <div className='row justify-content-center customer-input-row'>
                                            <div className='col-6'>
                                                    <h2 className='customer-update-input-title'>Additional Contact Email Address</h2>
                                                    <FormR.Control id="UpdateCustAdditionalEmail" type="text" defaultValue={customer.CustAdditionalContactEmail}></FormR.Control>
                                                </div>
                                                <div className='col-6'>
                                                </div>
                                            </div>

                                            <div className='row justify-content-center customer-button-row'>
                                                <div className='col-4'>
                                                    <Button variant="success" class="customer-input-button" type="submit">
                                                        Update
                                                    </Button>
                                                </div>
                                            </div>
                                        </FormR.Group>
                                    </FormR>
                                </div>
                            </Col>
                        </Row>
                    </Collapse>
                </div>
                <div className="customer-collapse-toggle-container">
                    <Row className="customer-collapse-toggle-wrapper gx-0">
                        <Col style={{display: "flex"}}>
                            <p className="customer-collapse-toggle" onClick={() => setCustomerTableOpen(!customerTableOpen)} aria-controls="example-collapse-text" aria-expanded={customerTableOpen}>View Proposals</p>
                            {/* <Button variant="primary" size="sm" onClick={SaveTable} style={{marginLeft: "auto"}}>Save Changes</Button> */}
                        </Col>
                    </Row>
                    <Collapse className="customer-collapse-content gx-0" in={customerTableOpen}>
                        <Row>
                            <Col className="customer-update-collapse-body">
                                {/* <Button
                                    onClick={handleAdd}
                                    type="primary"
                                    style={{
                                    marginBottom: 16,
                                    }}
                                >Add Row</Button>
                                <Button
                                    onClick={SaveTable}
                                    type="primary"
                                    style={{
                                    marginBottom: 16,
                                    }}
                                >Save Changes</Button> */}
                                {/* <Table 
                                components={components}
                                columns={propColumns} 
                                pagination={{ position: ["none", "none"] }} 
                                dataSource={proposalData}
                                footer={() => <div><Button onClick={handleProposalAdd}>Add</Button></div>}
                                expandable={{rowExpandable:(record2)=>true,
                                expandedRowRender:(record2)=>{
                                    return (
                                        <Table
                                        components={components}
                                        columns={inveHeadColumns} 
                                        pagination={{ position: ["none", "none"] }} 
                                        dataSource={record2.invoiceHeader}
                                        footer={() => <div><Button onClick={()=>handleInvoiceHeaderAdd(record2)}>Add</Button></div>}
                                        expandable={{rowExpandable:(subRecord)=>true,
                                            expandedRowRender:(subRecord)=>{
                                                return (
                                                <Table 
                                                components={components}
                                                columns={invLinecolumns} 
                                                footer={() => <div><Button onClick={()=>handleInvoiceLineAdd(subRecord)}>Add</Button></div>}
                                                pagination={{ position: ["none", "none"] }} 
                                                dataSource={subRecord.invoiceLines}>
                                                </Table>);
                                            }}}>
                                        </Table>);
                                    }}}>
                                </Table> */}
                            </Col>
                        </Row>
                    </Collapse>
                </div>
            </Container> 
        }

        {   customerId == 0 &&
            <Container fluid style={{marginTop: "40px"}}>
                <Row className="justify-content-md-center">
                    <Col xs={1}>
                    </Col>
                    <Col xs={6}>
                            <div id="customer-create-form">
                            <p className='customer-create-body-details-heading'>Customer Information</p>
                            <FormR noValidate validated={isCreateValidated} onSubmit={onCustomerCreateFormSubmitHandler}>
                                <FormR.Group className="mb-3" controlId="formBasicUsername">
                                    <div className='row justify-content-center customer-input-row'>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Customer Name</h2>
                                            <FormR.Control 
                                            id="CreateCustName" 
                                            type="text" 
                                            onChange={onCustomerNameChange}
                                            pattern="^[a-zA-Z 0-9()\-]+$"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid name</FormR.Control.Feedback>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Email Address</h2>
                                            <FormR.Control 
                                            id="CreateCustEmail" 
                                            type="email"
                                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" 
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid email address</FormR.Control.Feedback>
                                        </div>
                                    </div>

                                    <div className='row justify-content-center customer-input-row'>
                                        <div className='col-12'>
                                            <h2 className='customer-create-input-title'>Address</h2>
                                            <FormR.Control 
                                            id="CreateCustAddress" 
                                            type="text"
                                            pattern="^[a-zA-Z0-9 ]+$"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid address</FormR.Control.Feedback>
                                        </div>
                                    </div>

                                    <div className='row justify-content-center customer-input-row'>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Reg Number</h2>
                                            <FormR.Control 
                                            id="CreateCustRegNo" 
                                            type="text"
                                            pattern="^[a-zA-Z0-9 /\\]+$"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid registration number</FormR.Control.Feedback>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>VAT Number</h2>
                                            <FormR.Control 
                                            id="CreateCustVatNo" 
                                            type="text"
                                            pattern="^[0-9]+$"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid VAT number</FormR.Control.Feedback>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center customer-input-row'>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Payment Terms</h2>
                                            <FormR.Select 
                                                id="CreateCustPaymentTerms"
                                            >
                                                {paymentTerms.map((x) => (
                                                    <option value={x.PaymentTermId}>{x.PaymentTermDescription} days</option>
                                                ))}
                                                
                                            </FormR.Select>
                                        </div>
                                        <div className='col-6'>
                                            {/* <h2 className='customer-create-input-title'>Status</h2>
                                            <FormR.Control id="CreateCustStatus" type="text"></FormR.Control> */}
                                        </div>
                                    </div>

                                    <br/>

                                    <div className='row justify-content-center customer-input-row'>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Contact Name & Surname</h2>
                                            <FormR.Control 
                                            id="CreateCustContactName" 
                                            type="text"
                                            pattern="^[a-zA-Z ]+$"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid name</FormR.Control.Feedback>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Contact Mobile Number</h2>
                                            <FormR.Control 
                                            id="CreateCustContactNo" 
                                            type="text"
                                            pattern="^[0-9()+ ]{10,17}$"
                                            placeholder="(+27) 00 000 0000"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid mobile number</FormR.Control.Feedback>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center customer-input-row'>
                                    <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Contact Email Address</h2>
                                            <FormR.Control 
                                            id="CreateCustContactEmail" 
                                            type="email"
                                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                            required
                                            />
                                            <FormR.Control.Feedback type="invalid">Please enter a valid email address</FormR.Control.Feedback>
                                        </div>
                                        <div className='col-6'>
                                        </div>
                                    </div>

                                    <br/>

                                    <div className='row justify-content-center customer-input-row'>
                                        <Table 
                                            id="home-table" 
                                            pagination={{
                                                position: ["bottomCenter"],
                                                showSizeChanger: true,
                                                defaultPageSize: 5,
                                                hideOnSinglePage: false,
                                                pageSizeOptions: [5 , 10, 20, 50, 100]
                                            }}
                                            bordered="true" 
                                            components={components}
                                            columns={addContactColumns} 
                                            dataSource={addContactDetails}
                                            rowClassName="row-class-test"
                                            footer={() => (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                  }}
                                                >
                                                  <Button onClick={handleAdditionalContactAdd}>Add</Button>
                                                  <div style={{ display: "flex", gap: "20px" }}>
                                                    {/* <Button
                                                      variant="danger"
                                                      onClick={handleCancelModalShow}
                                                      style={{ alignSelf: "right" }}
                                                    >
                                                      Clear Changes
                                                    </Button>
                                                    <Button
                                                      variant="success"
                                                      onClick={SaveTable}
                                                      style={{ alignSelf: "right" }}
                                                    >
                                                      Save Changes
                                                    </Button> */}
                                                  </div>
                                                </div>
                                              )}
                                            >
                                        </Table>
                                        {/* <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Additional Contact Name & Surname</h2>
                                            <FormR.Control id="CreateCustAdditionalName" type="text"></FormR.Control>
                                        </div>
                                        <div className='col-6'>
                                            <h2 className='customer-create-input-title'>Additional Contact Mobile Number</h2>
                                            <FormR.Control id="CreateCustAdditionalNo" type="text"></FormR.Control>
                                        </div> */}
                                    </div>
                                    <div className='row justify-content-center customer-input-row'>
                                    </div>

                                    <div className='row justify-content-center customer-button-row'>
                                        <div className='col-4'>
                                            <Button variant="success" class="customer-input-button" type="submit">
                                                Create Customer
                                            </Button>
                                        </div>
                                    </div>
                                </FormR.Group>
                            </FormR>
                        </div>
                    </Col>
                    <Col xs={1}>
                        
                    </Col> 
                </Row>
            </Container> 
        }

      </div>
    );
  }
  
  export default Customer;
  